/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import './Dashboard.scss'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../routers/routes'
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Modal,
  Button,
} from '@material-ui/core'
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import GroupAddIcon from '@material-ui/icons/GroupAdd'
import logo from '../../assets/img/logoDash.png'
import { useAuthentication } from '../../context/authenticationContext'
// import Swal from 'sweetalert2'
import { validatePreElegibilityFormByUser } from '../../services/Elegibilidad/get'
import swal from 'sweetalert'
import { MasterLimitsAvailable } from '../../services/AsistenciaTecnica/create'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
// import { FormContextProvider } from '../../context/formContext'
// import AddIcon from '@mui/icons-material/Add'
// import ModalRegisterMipymes from '../IFIS/RegistroMipymesIfis/ModalRegisterMipymes'

const Dashboard = ({ userName }) => {
  const history = useHistory()
  const { UserRoles, userIDB2C, isAuthBackend } = useAuthentication()
  const [open, setOpen] = useState(false)
  const [validUser, setValidUser] = useState(false)
  const [validWorkshop, setValidWorkshop] = useState(false)

  // const [validWorkshop, setvalidWorkshop] = useState(t)

  // ROL DE MYPEME PANTALLAS DASHBOARD
  const createPreElegibilityForm = () => {
    history.push(ROUTES.REGISTRAR.pathname)
  }

  const createElegibilityForm = () => {
    history.push(ROUTES.REGISTRAR_ELEGIBILIDAD.pathname)
  }

  // const viewForm = () => {
  //   history.push(ROUTES.VISTA.pathname)
  // }

  // const viewDraftForms = () => {
  //   history.push(ROUTES.BORRADOR.pathname)
  // }
  const viewDraftEligibilidad = () => {
    history.push(ROUTES.BORRADORELEGIBILIDAD.pathname)
  }

  // Rol de IFI PANTALLAS DASHBOARD
  const createPreElegibilityFormIFI = () => {
    history.push(ROUTES.IFIREGISTRAR.pathname)
  }

  const createElegibilityFormIFI = async () => {
    try {
      const response = await MasterLimitsAvailable(1)
      if (response.Success) {
        if (response.Data.ThereIsAvailable) {
          history.push(ROUTES.IFIREGISTRAR_ELEGIBILIDAD.pathname)
        } else {
          swal({
            title: `Ha ocurrido un problema`,
            text: `La disponibilidad de fondos de crédito se ha agotado`,
            icon: `error`,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
              catch: {
                text: 'Continuar',
                value: 'catch',
              },
            },
          })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const createAsistenciaTecnica = async () => {
    try {
      const response = await MasterLimitsAvailable(2)
      if (response.Success) {
        if (response.Data.ThereIsAvailable) {
          history.push(ROUTES.ASISTENCIATECNICA.pathname, {
            idForm: 0,
            edit: false,
          })
        } else {
          swal({
            title: `Ha ocurrido un problema`,
            text: `La disponibilidad de fondos de asistencia técnica se ha agotado`,
            icon: `error`,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
              catch: {
                text: 'Continuar',
                value: 'catch',
              },
            },
          })
        }
      }
    } catch (error) {}
  }

  // const viewDraftFormsIFI = () => {
  //   history.push(ROUTES.IFIBORRADOR.pathname)
  // }
  const viewDraftEligibilidadIFI = () => {
    history.push(ROUTES.IFIBORRADORELEGIBILIDAD.pathname)
  }
  // FORMULARIO ENVIADO NUEVO SOLO PARA IFI DE MOMENTO....
  const viewFormsSentIFI = () => {
    history.push(ROUTES.IFIFORMSSENT.pathname)
  }

  const viewFormsSentMIPYME = () => {
    history.push(ROUTES.MIPYMEFORMSENT.pathname)
  }

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const createMonitoreoYEvaluacion = async () => {
    history.push(ROUTES.MONITOREOYEVALUACION.pathname, {
      idForm: 0,
      edit: false,
    })
  }

  // const [openRegister, setOpenRegister] = useState(false)

  // /* ::REGISTER:: */
  // const handleOpenRegister = () => setOpenRegister(true)
  // const handleCloseRegister = () => setOpenRegister(false)

  const getValidation = async () => {
    try {
      const response = await validatePreElegibilityFormByUser(userIDB2C)

      if (response.Success) {
        if (
          response.Data.HasPreElegibility &&
          response.Data.HasWorkshop &&
          !response.Data.HasRepresentation
        ) {
          setValidWorkshop(true)
        } else {
          setValidWorkshop(false)
        }

        if (
          response.Data.HasPreElegibility &&
          response.Data.HasWorkshop &&
          response.Data.HasRepresentation
        ) {
          setValidUser(true)
        } else {
          setValidUser(false)
        }
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    getValidation()
  }, [isAuthBackend])

  return (
    <>
      {UserRoles && UserRoles.includes('IFI') ? (
        <div className="dashboard">
          <Grid
            container
            spacing={4} /* style={{marginTop: '18px', marginBottom: '36px'}} */
            md={12}
            sm={12}
            xs={12}
          >
            {/* <Grid className="ifiBack">
              <AddIcon
                className="ifiIcon"
                style={{
                  fontSize: '30px',
                }}
                onClick={() => handleOpenRegister()}
                disabled={true}
              />
              <FormContextProvider>
                <ModalRegisterMipymes
                  open={openRegister}
                  handleClose={() => handleCloseRegister()}
                />
              </FormContextProvider>
            </Grid> */}
            <Grid className="Titles" md={12} sm={12} xs={12}>
              <Grid item xs={12} sm={6} md={6}>
                <div className="dashImage">
                  <img src={logo} />
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <div className="dashTitle">
                  <h1>Bienvenid@ {userName}</h1>
                </div>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ paddingTop: '0px' }}>
              <div className="dashTitle2">
                <h3>¿Dónde quieres empezar?</h3>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={4}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => handleOpen()}
              >
                <div className="cardIcon">
                  <GroupAddIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Registro de nuevo(s) <br /> formulario(s)
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Registre un nuevo formulario para aplicar al programa.
                </Typography>
              </Card>
            </Grid>

            {/* <Grid item xs={12} sm={12} md={4}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => viewDraftFormsIFI()}
              >
                <div className="cardIcon">
                  <QueuePlayNextIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Formulario(s) <br /> a completar
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Administre formulario(s) no completado(s), asociado(s) a la
                  MIPYME.
                </Typography>
              </Card>
            </Grid> */}

            <Grid item xs={12} sm={12} md={4}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => viewDraftEligibilidadIFI()}
              >
                <div className="cardIcon">
                  <QueuePlayNextIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Formulario(s) <br /> por completar
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Administre formulario(s) no completado(s).
                </Typography>
              </Card>
            </Grid>

            {/* <Grid item xs={12} sm={12} md={3}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                // onClick={() => viewFormIFI()}
                onClick={() => {
                  Swal.fire({
                    title: 'PROCESO EN CONSTRUCCIÓN',
                    text: 'Esta operación esta en construcción...',
                    icon: 'info',
                    // showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Confirmar',
                    allowOutsideClick: false,
                  })
                }}
              >
                <div className="cardIcon">
                  <PlaylistAddCheckIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Formulario(s) <br /> enviado(s)
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Consulte formulario(s) enviado(s) al programa.
                </Typography>
              </Card>
            </Grid> */}

            <Grid item xs={12} sm={12} md={4}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => viewFormsSentIFI()}
              >
                <div className="cardIcon">
                  <PlaylistAddCheckIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Formulario(s) <br /> enviado(s)
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Consulte formulario(s) enviado(s) al programa.
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </div>
      ) : (
        // ELSE-----------------------------------------------------------------------------------------
        <div className="dashboard">
          <Grid
            container
            spacing={4} /* style={{marginTop: '18px', marginBottom: '36px'}} */
            md={12}
            sm={12}
            xs={12}
          >
            <Grid className="Titles" md={12} sm={12} xs={12}>
              <Grid item xs={12} sm={6} md={6}>
                <div className="dashImage">
                  <img src={logo} />
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <div className="dashTitle">
                  <h1>Bienvenid@ {userName}</h1>
                </div>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ paddingTop: '0px' }}>
              <div className="dashTitle2">
                <h3>¿Dónde quieres empezar?</h3>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={4}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => handleOpen()}
              >
                <div className="cardIcon">
                  <GroupAddIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Registro de nuevo(s) <br /> formulario(s)
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Registre un nuevo formulario asociado a su MIPYME para aplicar
                  al programa.
                </Typography>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={4}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => viewDraftEligibilidad()}
              >
                <div className="cardIcon">
                  <QueuePlayNextIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Formulario(s) <br /> por completar
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Administre formulario(s) no completado(s), asociado(s) a la
                  MIPYME.
                </Typography>
              </Card>
            </Grid>

            {/* <Grid item xs={12} sm={12} md={4}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => viewForm()}
              >
                <div className="cardIcon">
                  <PlaylistAddCheckIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Formulario(s) <br /> enviado(s)
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Consulte formulario(s) enviado(s) al programa, asociado(s) a
                  la MIPYME.
                </Typography>
              </Card>
            </Grid> */}
            <Grid item xs={12} sm={12} md={4}>
              <Card
                variant="outlined"
                className="Card"
                style={{
                  borderRadius: '20px',
                  borderColor: '#76d4b1',
                  borderWidth: '2px',
                  height: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => viewFormsSentMIPYME()}
              >
                <div className="cardIcon">
                  <PlaylistAddCheckIcon />
                </div>
                <CardContent>
                  <Typography
                    className="cardTitle"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    Formulario(s) <br /> enviado(s)
                  </Typography>
                </CardContent>
                <Typography className="cardDescription" variant="body2">
                  Consulte formulario(s) enviado(s) al programa, asociado(s) a
                  la MIPYME.
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      {UserRoles && UserRoles.includes('IFI') ? (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="stage-modal-content">
            <h4 className="title">Seleccione la etapa</h4>
            <hr />
            <div style={{ textAlign: 'center', textTransform: 'uppercase' }}>
              <Grid container spacing={1} className="input__container">
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="stage-modal-item"
                  onClick={() => createPreElegibilityFormIFI()}
                >
                  <label>Pre-elegibilidad</label>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="stage-modal-item"
                  onClick={() => createElegibilityFormIFI()}
                >
                  <label>Elegibilidad</label>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="stage-modal-item"
                  onClick={() => createAsistenciaTecnica()}
                >
                  <label>Asistencia Técnica</label>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="stage-modal-item"
                  onClick={() => createMonitoreoYEvaluacion()}
                >
                  <label>Monitoreo y Evaluación</label>
                </Grid>
                {/* <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="stage-modal-item-disabled"
                >
                  <label>Seguimiento y Monitoreo</label>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="stage-modal-item-disabled"
                >
                  <label>Premio de adaptación</label>
                </Grid> */}
              </Grid>
            </div>
            <div style={{ textAlign: 'right', marginTop: '8px' }}>
              <Button color="primary" onClick={handleClose}>
                Cerrar
              </Button>
            </div>
          </div>
        </Modal>
      ) : (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="stage-modal-content">
            <h4 className="title">Seleccione la etapa</h4>
            <hr />
            <div style={{ textAlign: 'center', textTransform: 'uppercase' }}>
              <Grid container spacing={1} className="input__container">
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="stage-modal-item"
                  onClick={() => createPreElegibilityForm()}
                >
                  <label>Pre-elegibilidad</label>
                </Grid>

                {validUser ? (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="stage-modal-item"
                    onClick={() => createElegibilityForm()}
                  >
                    {' '}
                    <label>Elegibilidad</label>
                  </Grid>
                ) : null}

                {validWorkshop ? (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    // className="stage-modal-item"

                    // onClick={() => createElegibilityForm()}
                  >
                    {' '}
                    <label style={{ color: 'gray' }}>Elegibilidad</label>
                    <a
                      data-tip="Para llenar un formulario de Elegibilidad necesita tener la representación de una IFI"
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </Grid>
                ) : null}

                {/* <Grid item xs={12} sm={12} md={12} className="stage-modal-item-disabled">
                <label>Elegibilidad</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12} className="stage-modal-item-disabled">
                <label>Asistencia Técnica</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12} className="stage-modal-item-disabled">
                <label>Seguimiento y Monitoreo</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12} className="stage-modal-item-disabled">
                <label>Premio de adaptación</label>
              </Grid> */}
              </Grid>
            </div>
            <div style={{ textAlign: 'right', marginTop: '8px' }}>
              <Button color="primary" onClick={handleClose}>
                Cerrar
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}

export default Dashboard
